import React, { useEffect } from 'react';
import { useFocusIdx } from '@bay-email/editor';
import { RadioGroupField } from '../../../components/Form';
import { useField } from 'react-final-form';
import { t } from '@bay-email/core';

const options = [
	{
		value: 'initial',
		get label() {
			return t('None');
		},
	},
	{
		value: 'uppercase',
		label: 'ABC',
	},
	{
		value: 'lowercase',
		label: 'abc',
	},
	{
		value: 'capitalize',
		label: 'Abc',
	},
];

export function TextTransform({ name }: { name?: string }) {
	const { focusIdx } = useFocusIdx();

	const fieldName = name || `${focusIdx}.attributes.text-transform`;
	const { input } = useField<string | undefined>(fieldName, {
		subscription: {
			value: true,
		},
	});

	useEffect(() => {
		if ((input.value === undefined || input.value === '') && focusIdx) {
			input.onChange('initial');
		}
	}, [focusIdx, input]);

	return (
		<RadioGroupField
			label={t('Text transform')}
			name={fieldName}
			options={options}
			type='button'
			formItem={{ style: { marginBottom: '8px' } }}
		/>
	);
}
